import BaseResource from './BaseResource'

export default class AttributeMappings extends BaseResource {
  static endpoint = '/api/v1/attributeMappings' // /profile
}
